import { Component } from '@angular/core';
import { TitleCardModel } from '../../../../models/title-card.model';

@Component({
  selector: 'app-colleges',
  templateUrl: './colleges.component.html',
  styleUrl: './colleges.component.scss',
  standalone: false,
})
export class CollegesComponent {
  public titleCard: TitleCardModel = {
    image: '../../../assets/images/placeholder.svg',
  };
}
